'use client';

import React, {FC} from 'react';
import {LayoutPlatform} from '@/_application/themes/kidsplaza-spring/layouts/components/layout-platform';
import {DynamicPageServerSideProps} from '@/_application/core/types';

interface MainLayoutClientProps {
    children: React.ReactNode;
    layoutData: DynamicPageServerSideProps['variables'];
    isMobile: boolean;
}

export const MainLayoutClient: FC<MainLayoutClientProps> = ({children, layoutData, isMobile}) => {
    return (
        <LayoutPlatform isMobile={isMobile} variables={layoutData}>
            {children}
        </LayoutPlatform>
    );
};
